import React, { useState } from "react";
import BreadcrumbContext, { BreadcrumbItem } from "./BreadcrumbContext";

type Props = {
	children?: React.ReactNode;
};

const BreadcrumbProvider: React.FC<Props> = ({ children }) => {
	const [breadcrumb, setBreadcrumb] = useState<BreadcrumbItem[]>([]);

	return <BreadcrumbContext.Provider value={{ breadcrumb, setBreadcrumb }}>{children}</BreadcrumbContext.Provider>;
};
export default BreadcrumbProvider;
